module.exports = require('./helpers/bundle-url').getBundleURL('9G649') + "match-browser.defc82cb.svg";